/* eslint-disable jsx-a11y/anchor-has-content */
import { Ring } from '@uiball/loaders'
import ELicenseKK from 'assets/files/damu-elicense-kk.pdf'
import ELicenseRU from 'assets/files/damu-elicense-ru.pdf'
import DocumentologKKFile from 'assets/files/documentolog-kk.pdf'
import DocumentologRUFile from 'assets/files/documentolog-ru.pdf'
import ContainerWithSteps from 'components/UI/Container/ContainerWithSteps'
import Typography from 'components/UI/Typography'
import { useAppSelector } from 'hooks'
import { useEffect, useMemo } from 'react'
import { Trans, useTranslation } from 'react-i18next'
import { useGetApplicationStatusQuery } from 'redux/api'
import { getCurrentFlowId } from 'redux/store/slices/userSlice'
import { getNotificationsSelector } from 'redux/store/slices/wsSlice'
import { ApplicationEvents } from 'share/enums/events'
import { FLOW_STEPS } from 'share/types'
import tw from 'twin.macro'
import { getWsStepStatus, isStepHaveData } from 'utils'
import Emitter from 'utils/emitter'

const getELicenseUrl = (language: string) => {
  if (language === 'ru') return 'https://elicense.kz/?lang=ru'
  return 'https://elicense.kz/?lang=kk'
}
const getELicenseFile = (language: string) => {
  if (language === 'ru') return ELicenseRU
  return ELicenseKK
}

const getDocumentologFile = (lang: string) => {
  if (lang === 'ru') return DocumentologRUFile
  return DocumentologKKFile
}

const DamuVerification = () => {
  // Tools
  const {
    t,
    i18n: { language }
  } = useTranslation()

  // Selectors
  const currentFlowId = useAppSelector(getCurrentFlowId)
  const { CHECK_ELICENSE } = useAppSelector(getNotificationsSelector)

  // Queries
  const { data, isLoading } = useGetApplicationStatusQuery(currentFlowId as string, {
    skip: !currentFlowId
  })

  const isNikadAvailable = useMemo(() => {
    if (!data) return false
    const { current_step } = data
    if (!current_step) return false

    if (current_step.step === FLOW_STEPS.CHECK_ELICENSE && isStepHaveData<{ nikad: boolean }>(current_step.data))
      return current_step.data.nikad

    return false
  }, [data])

  useEffect(() => {
    const stepStatus = getWsStepStatus(CHECK_ELICENSE)
    if (stepStatus !== 'DONE') return
    Emitter.emit(ApplicationEvents.NAVIGATE_TO_NEXT_PAGE)
  }, [CHECK_ELICENSE])

  if (isLoading) {
    return (
      <ContainerWithSteps>
        <div tw='flex items-center justify-center my-auto'>
          <Ring size={80} color='var(--primary-color)' />
        </div>
      </ContainerWithSteps>
    )
  }

  return (
    <ContainerWithSteps>
      <div tw='flex flex-col'>
        <Typography variant='body' weight='bold'>
          {t('damu-verification.fraud-text')}
        </Typography>
        <Typography variant='body' twStyle={tw`mt-2`}>
          {t('damu-verification.we-inform')}
        </Typography>
        {!isNikadAvailable && (
          <Typography variant='body' weight='medium' twStyle={tw`mt-4`}>
            <Trans
              i18nKey='damu-verification.ticket-not-found'
              components={{
                1: <a tw='text-primary' href={getELicenseUrl(language)} />,
                2: <a tw='text-primary' href={getELicenseFile(language)} />
              }}
            />
          </Typography>
        )}
        <Typography variant='body' weight='medium' twStyle={tw`mt-4`}>
          <Trans
            i18nKey='damu-verification.sign-docs'
            components={{
              1: <a tw='text-primary' href='https://business.documentolog.com' />,
              2: <a tw='text-primary' href={getDocumentologFile(language)} />
            }}
          />
        </Typography>
      </div>
    </ContainerWithSteps>
  )
}

export default DamuVerification
